export default "__VITE_PUBLIC_ASSET__c04461ea__"